import { render, staticRenderFns } from "./HighPotentialNewCustomerDataTable.vue?vue&type=template&id=19ab34db&scoped=true"
import script from "./HighPotentialNewCustomerDataTable.vue?vue&type=script&lang=js"
export * from "./HighPotentialNewCustomerDataTable.vue?vue&type=script&lang=js"
import style0 from "./HighPotentialNewCustomerDataTable.vue?vue&type=style&index=0&id=19ab34db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ab34db",
  null
  
)

export default component.exports